import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const DeletePluginListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePluginListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pluginListingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePluginListing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pluginId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}}},{"kind":"Argument","name":{"kind":"Name","value":"pluginListingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pluginListingId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"DeletePluginListing","document":DeletePluginListingDocument}} as const;
export type DeletePluginListingMutationVariables = Types.Exact<{
  idPlugin: Types.Scalars['ID']['input'];
  pluginListingId: Types.Scalars['ID']['input'];
}>;


export type DeletePluginListingMutation = (
  { __typename: 'Mutation' }
  & { deletePluginListing?: Types.Maybe<(
    { __typename: 'Plugin_Listing_DeleteResponse' }
    & Pick<Types.Plugin_Listing_DeleteResponse, 'success'>
  )> }
);

export type DeletePluginListingMutationFn = Apollo.MutationFunction<
  DeletePluginListingMutation,
  DeletePluginListingMutationVariables
>;

/**
 * __useDeletePluginListingMutation__
 *
 * To run a mutation, you first call `useDeletePluginListingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePluginListingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePluginListingMutation, { data, loading, error }] = useDeletePluginListingMutation({
 *   variables: {
 *      idPlugin: // value for 'idPlugin'
 *      pluginListingId: // value for 'pluginListingId'
 *   },
 * });
 */
export function useDeletePluginListingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeletePluginListingMutation,
    DeletePluginListingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeletePluginListingMutation,
    DeletePluginListingMutationVariables
  >(DeletePluginListingDocument, options);
}
export type DeletePluginListingMutationHookResult = ReturnType<
  typeof useDeletePluginListingMutation
>;
export type DeletePluginListingMutationResult =
  Apollo.MutationResult<DeletePluginListingMutation>;
export type DeletePluginListingMutationOptions = Apollo.BaseMutationOptions<
  DeletePluginListingMutation,
  DeletePluginListingMutationVariables
>;
